var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"row row-parent is-expanded"},[_c('td',{staticClass:"cell-child-table",attrs:{"colspan":_vm.colspan}},[_vm._t("childTable",null,{"data":_vm.childData,"columns":_vm.childColumns})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }